import React, { useState, useEffect, useRef } from "react";
import { debounce } from "lodash";
import "./zoompic.less";
import $ from "jquery";
import objectFitImages from 'object-fit-images';
// 图片缩放组件
/**
 *
 * @param {*} param0
 * path: 放大缩小的图（业务里 ）
 * hdPath：  放大缩小的高清图
 *
 * 优化： 这里 jquery 用于便捷的 DOM 操作，
 * 完全可以被原生 DOM API 代替， 实现和 jquery 的解耦
 */

let imgratio = 0; // 图片比例
let boxratio = 0; // 容器比例
let containerHieht = 0; // 容器高
let containerWidth = 0; // 容器宽
let naturalHeight = 0; // 图片原始高
let naturalWidth = 0; // 图片原始宽
let minWidth = 0; // 最小宽
let minHeight = 0; // 最小高
let newWidth = 0; // 放大缩小后新宽度
let newHeight = 0; // 缩小放大后新高度
let hwb = 0; // 通过这个比例我们可以知道哪个边先到达极限
let nnw = 0; // 最大宽
let nnh = 0; // 最大高


let startX = 0;  // 拖拽开始的 clientX
let startY = 0;  // 拖拽开始的 clientY
let originLeft = 0;  // 上一次拖拽的原始left位置 
let originTop = 0;  // 上一次拖拽的原始top位置 


const ZoomPic = ({ path = "", hdPath = "", setImgSize = () => { }, reset = () => { } }) => {
	// 0 加载中  200加载完成   500加载失败
	const [status, setStatus] = useState(0);
	const [zoomImgBoxStyles, setZoomImgBoxStyles] = useState({});

	// 大图详情
	const bigImgInfo = useRef(null);
	// 缩放容器
	const zoomContainerRef = useRef(null);
	const imgBoxRef = useRef(null);

	const handleResize = () => {
		init(path);
	};

	const debounceResize = debounce(handleResize, 200);
	useEffect(() => {
		// 获得高清图 原始尺寸
		window.addEventListener("resize", debounceResize);
		return () => {
			window.removeEventListener("resize", debounceResize);
			$('#zoomContainerId').off('mousemove')
		}
	}, []);

	useEffect(() => {
		init(path);
	}, [path])

	const init = (path) => {
		try {
			let bigImage = new Image();
			bigImage.src = path;
			//加载放大图片
			bigImage.onload = function () {
				setTimeout(() => {
					const imgs = document.querySelectorAll('img');
					objectFitImages(imgs);
				}, 300);

				setStatus(200);
				//设置图片属性
				// console.log(bigImage, bigImage.width, bigImage.height);
				// 图片的原始信息
				bigImgInfo.current = {
					width: bigImage.width,
					height: bigImage.height,
					ratio: bigImage.width / bigImage.height,
				};
				// 获得包裹缩放组件容器的高度
				setZoomImg(bigImage, bigImage.width, bigImage.height);
				setImgSize({
					group_name: "尺寸",
					tag_name: `${bigImage.width}*${bigImage.height}`,
				});
			};
			bigImage.onerror = function () {
				setStatus(500);
			};
		} catch (error) {
			console.log("zoom-init-error", error);
		}
	};

	const change = (el, ow, ish, cb) => {
		// ish true: 高大   false: 宽大
		var bodyHeight = containerHieht;
		var _tw = ish ? containerHieht : containerWidth;

		var _th = ish ? naturalHeight : naturalWidth;

		var _h = _tw > _th ? _th : _tw;

		if (_th < _h) {
			return false;
		}
		if (ow <= _h) {
			if (ish) {
				// el.width(minWidth);
				// el.height(_h);
				cb && cb(minWidth, _h)
				if (_h < bodyHeight - 1) return false;
				el.css("margin-top", 0);
			} else {
				// el.width(_h);
				// el.height("auto");
				let hei = _h / (naturalWidth / naturalHeight)
				let hh = _h
				cb && cb(hh, hei)
			}
			return false;
		}
		el.css("cursor", 'pointer')
		return true;
	};

	const judge = (w, h) => {
		//图片放大限制条件
		var nw = 0,
			nh = 0;
		if (w < 2000 && w >= 1300) {
			nw = w * 1.5;
			nh = h * 1.5;
		} else if (w < 1300 && w >= 800) {
			nw = w * 2;
			nh = h * 2;
		} else if (w < 800 && w >= 500) {
			nw = w * 2.5;
			nh = h * 2.5;
		} else if (w < 500) {
			nw = w * 3;
			nh = h * 3;
		} else {
			nw = w;
			nh = h;
		}
		return {
			nw: nw,
			nh: nh,
		};
	};

	// 鼠标移动 方案
	const setImgMoveFunc = (el, e) => {
		if (hwb) {
			if ($(el).height() <= containerHieht) {
				return false;
			}
		} else {
			if ($(el).width() <= containerWidth) {
				return false;
			}
		}
		var mLeft = parseInt($(el).css("margin-left"));
		var mTop = parseInt($(el).css("margin-top"));
		//var scaleY=(oEvent.clientY-offsetTop)/oldHeight;
		var top =
			(e.clientY / containerHieht) * $(el).height() - containerHieht / 2;
		var left =
			((e.clientX - 236) / containerWidth) * newWidth -
			containerWidth / 2;
		if ($(el).width() <= containerWidth) {
			left = 0;
		} else if ($(el).height() <= containerHieht) {
			top = -(containerHieht - $(el).height()) / 2;
		}
		$(el).css({
			marginTop: -top,
			marginLeft: left == 0 ? "auto" : -left,
		});
	};

	// 鼠标按下 拖拽方案
	const setImgDragFunc = (el, e) => {

		let imgHeight = $(el).height()
		let imgWidth = $(el).width()
		if (hwb) {
			if ($(el).height() <= containerHieht) {
				// return false;
			}
		} else {
			if ($(el).width() <= containerWidth) {
				// return false;
			}
		}

		let mLeft = originLeft;
		let mTop = originTop;

		// console.log(` 原始位置left: ${mLeft},原始位置top: ${mTop}，移动距离x： ${e.clientX - startX}----移动距离Y：${e.clientY - startY}`);
		// let zoomNumber = $(el).height() / containerHieht
		let distanceX = mLeft + (e.clientX - startX) * 1
		let distanceY = mTop + (e.clientY - startY) * 1


		// 上下左右保护 50px
		let safeContainerWidth = containerWidth - 100
		let safeContainerHieht = containerHieht - 100
		let safeImgWidth = imgWidth - 100
		let safeImgHeight = imgHeight - 100

		if (distanceX >= safeContainerWidth) {
			distanceX = safeContainerWidth
		} else if (distanceX < (-safeImgWidth)) {
			distanceX = (-safeImgWidth)
		}

		if (distanceY >= safeContainerHieht) {
			distanceY = safeContainerHieht
		} else if (distanceY < (-safeImgHeight)) {
			distanceY = (-safeImgHeight)
		}


		$(el).css({
			marginTop: distanceY,
			marginLeft: distanceX == 0 ? "auto" : distanceX,
		});
	};

	// 设置 缩放图片
	const setZoomImg = (el, w, h) => {
		// 获得容器的宽高
		if (zoomContainerRef !== null && zoomContainerRef.current) {
			// console.log(zoomContainerRef, 'zoomContainerRef');
			const zoomContainerDom = zoomContainerRef.current;
			const containerInfo = zoomContainerDom.getBoundingClientRect();
			// console.log(containerInfo.height, containerInfo.width);

			containerHieht = containerInfo.height;
			// 减去侧边栏宽度 236px
			containerWidth = containerInfo.width;
			// 通过这个比例我们可以知道哪个边先到达极限
			boxratio = containerInfo.height / containerInfo.width;
			imgratio = h / w;
			hwb = h / w > boxratio;

			naturalHeight = el.height;
			naturalWidth = el.width;
			// 计算图片宽高比
			let _width, _height, _marginTop;
			// console.log('imgratio:', imgratio, '  boxratio:', boxratio);
			if (imgratio > boxratio) {
				// 高先到达
				//如果图片实际高度小于屏幕高度时，显示图片原始高度
				if (h > containerHieht) {
					minWidth = (containerHieht * w) / h;
					(_height = containerHieht), (_width = minWidth);
				} else {
					minWidth = (naturalHeight * w) / h;
					(_height = naturalHeight), (_width = minWidth);
				}
				//设置图片上下居中
				if (_height < containerHieht) {
					_marginTop = (containerHieht - _height) / 2;
				} else {
					_marginTop = 0;
				}
			} else {
				//如果图片实际宽度小于屏幕宽度时，显示图片原始宽度
				if (naturalWidth > containerWidth) {
					minHeight = (containerWidth * h) / w;
					(_height = minHeight), (_width = containerWidth);
				} else {
					minHeight = (naturalWidth * h) / w;
					(_height = minHeight), (_width = naturalWidth);
				}
				//设置图片上下居中
				if (_height < containerHieht) {
					_marginTop = (containerHieht - _height) / 2;
				} else {
					_marginTop = 0;
				}
			}

			setZoomImgBoxStyles({
				height: _height,
				width: _width,
				// 一开始设置图片尺寸， _height 不可能大于 containerHieht
				margin: `${(containerHieht - _height) / 2}px 0px 0px ${(containerWidth - _width) / 2}px`,
			});
			// 主要是为了resize 的时候去掉以前 css 的影响


			let whArray = judge(naturalWidth, naturalHeight);
			nnw = whArray.nw;
			nnh = whArray.nh;
		}
	};

	const fnWheel = (el, down, startPonit) => {
		let oldWidth = el.width();
		let oldHeight = el.height();
		let oldLeft = parseInt(el.css("margin-left")) || 0;
		let oldTop = parseInt(el.css("margin-top")) || 0;

		newWidth = el.width();
		newHeight = el.height();

		let newWidth1 = oldWidth;
		let newHeight1 = oldHeight


		if (down) {
			if (hwb) {
				if (change(el, oldHeight, true) == false) {
					change(el, oldHeight, true, (x, y) => {
						newWidth1 = x
						newHeight1 = y
					})
				} else {
					newWidth1 = oldWidth * 0.95
					newHeight1 = oldHeight * 0.95
				}

			} else {
				if (change(el, oldWidth, false) == false) {
					change(el, oldHeight, false, (x, y) => {
						newWidth1 = x
						newHeight1 = y
					})
				} else {
					newWidth1 = oldWidth * 0.95
					newHeight1 = oldHeight * 0.95
				}
			}
			// el.css('cursor', 'pointer')

		} else {
			// console.log('放大', this.hwb);
			let isNoMax = true
			if (hwb) {
				if (oldHeight >= nnh) {
					newWidth1 = nnw
					newHeight1 = nnh
					// return false;
					isNoMax = false
				}
			} else {
				if (oldWidth >= nnw) {
					newWidth1 = nnw
					newHeight1 = nnh
					// return false;
					isNoMax = false
				}
			}
			if (isNoMax) {
				// el.css('cursor', 'pointer')
				newWidth1 = oldWidth * 1.05
				newHeight1 = oldHeight * 1.05
			}

		}
		el.width(newWidth1 + "px");
		el.height(newHeight1 + "px");

		// jquery 计算的 top 值 在： 印花图案-二方连续下  不准
		// let marginLeft = el.offset().left
		// let marginTop = el.offset().top
		let marginLeft = oldLeft
		let marginTop = oldTop

		// 如何得到 margin-left   ？
		// 鼠标位置在图片的对应位置 =  (起始x - 图片与容器左边的距离) / 放大缩小前图片的高度  
		// 最终margin-left = 原始位置 -  鼠标位置在图片的对应位置 * 本次放大缩小的尺寸
		// console.log(oldLeft, startPonit.x, marginLeft, oldWidth, (newWidth1 - oldWidth), el.offset(), oldLeft - ((startPonit.x - marginLeft) / oldWidth) * (newWidth1 - oldWidth));
		// console.log('-------------------111111--------------------');
		// console.log(oldTop, startPonit.y, marginTop, oldHeight, (newHeight1 - oldHeight), el.offset(), oldTop - ((startPonit.y - marginTop) / oldHeight) * (newHeight1 - oldHeight));
		// console.log('-------------------222222--------------------');

		// 不用 Math.round 会导致每次计算结果都会 1px 的差距，导致图片漂移
		el.css("margin-left", Math.round(oldLeft - ((startPonit.x - marginLeft) / oldWidth) * (newWidth1 - oldWidth)));
		el.css("margin-top", Math.round(oldTop - ((startPonit.y - marginTop) / oldHeight) * (newHeight1 - oldHeight)));
	};

	const handleWheel = (event) => {
		// 进入缩放状态
		event.preventDefault();
		// console.log("进入缩放状态。。。", event.deltaY);
		if (event.deltaY < 0) {
			// console.log("放大");
			if (imgBoxRef !== null) {
				fnWheel($(imgBoxRef.current), false, { x: event.clientX, y: event.clientY });
			}
		} else {
			// console.log("缩小");
			fnWheel($(imgBoxRef.current), true, { x: event.clientX, y: event.clientY });
		}
		return false;
	};

	const moveHandle = (e) => {
		// e.preventDefault();
		setImgDragFunc($(imgBoxRef.current), e, startX, startY);
	}

	const handleMouseMove = (event) => {
		event.preventDefault();
		startX = event.clientX
		startY = event.clientY

		originLeft = parseInt($(imgBoxRef.current).css("margin-left"));
		originTop = parseInt($(imgBoxRef.current).css("margin-top"));

		$('#zoomContainerId').on('mousemove', moveHandle)
	};

	const handleMouseUp = (event) => {
		event.preventDefault();
		$('#zoomContainerId').off('mousemove')
	}

	// 放大  基于中心放大
	const enlarge = () => {
		fnWheel($(imgBoxRef.current), false, { x: containerWidth / 2, y: containerHieht / 2 });
	};

	// 缩小 基于中心缩小
	const narrow = () => {
		fnWheel($(imgBoxRef.current), true, { x: containerWidth / 2, y: containerHieht / 2 });
	};

	// 重置
	const resetComponent = () => {
		// 暂时没有好的 重置方法(待优化)
		// for (let index = 0; index <= 30; index++) {
		// 	let timeId = setTimeout(() => {
		// 		fnWheel($(imgBoxRef.current), true, {x: containerWidth/2, y: containerHieht/2});
		// 		clearTimeout(timeId);
		// 	}, 10 * index);
		// }

		reset()
	};

	return (
		<div onMouseLeave={handleMouseUp} onWheel={handleWheel} className="zoom-pic" ref={zoomContainerRef} style={{ width: '100%', height: '100%' }}>
			<div id="zoomContainerId" onMouseDown={handleMouseMove} onMouseUp={handleMouseUp} className="zoom-container" style={{ width: '100%', height: '100%' }}>
				<div
					ref={imgBoxRef}
					// style={zoomImgBoxStyles}
					style={{ width: '100%', height: '100%' }}
					className="zoom-img-box"

				>
					{status === 0 && (
						<div className="msg-info">
							{/* <span>图片加载中...</span>{" "} */}
							<img
								style={{ width: 50 }}
								src="/static/resource/images/icon/loading-modal.svg"
							/>
						</div>
					)}
					{/* {status === 200 && (
						<img
							src={path}
							style={{
								objectFit: 'scale-down',
								objectPosition: 'center center',
								fontFamily: 'object-fit: scale-down; object-position: center center;',
							}}
						/>
					)} */}
					<img
						src={path}
						style={{
							visibility: status === 200 ? 'visible' : 'hidden',
							objectFit: 'scale-down',
							objectPosition: 'center center',
							fontFamily: 'object-fit: scale-down; object-position: center center',
						}}
					/>
					{status === 500 && (
						<div className="msg-info">
							<span>图片加载失败， 请重试...</span>{" "}
						</div>
					)}
				</div>
			</div>
			{/* 缩放操作 */}
			<div onMouseUp={handleMouseUp} className="zoom-operation">
				<div title="重置" className="operation-item" onClick={resetComponent}>
					<i className="iconfont iconlanmuyeicon_chushibili"></i>
				</div>
				<div title={"缩小"} className="operation-item" onClick={narrow}>
					<i className="iconfont iconlanmuyeicon_suoxiao"></i>
				</div>
				<div title="放大" className="operation-item" onClick={enlarge}>
					<i className="iconfont iconlanmuyeicon_fangda"></i>
				</div>
			</div>
		</div>
	);
};

export default ZoomPic;
